import useGlobalObjectChecker from "./useGlobalObjectChecker"

/**
 * CrossSellTracker 检查器
 * 专门用于等待 CrossSellTracker 全局对象加载完成
 * 使用预设配置：300ms 间隔，最多重试 5 次
 */
const useCrossSellTracker = (onReady: () => void, enabled = true) => {
  return useGlobalObjectChecker({
    globalKey: "CrossSellTracker",
    onReady,
    enabled,
  })
}

export default useCrossSellTracker 